module.exports = __webpack_public_path__ + "8d950c1e8a4c543011e9daf7c55af224.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/sms-services/sms-purchase/sms-purchase.html
// module id = 2025
// module chunks = 0